module.exports = __webpack_public_path__ + "img/exhibit2.293eb07c.png";